/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var sales = "";
  var salescommision = "";
  var devicerental = "";
  var datarental = "";
  var outstanding = "";
  var winningcommission = "";

  var details = function details() {
    $(".card-details").show();
  };

  var check = function check() {
    $f7.request({
      method: 'get',
      url: window.waypointGEN + 'json/checkoutstanding.aspx',
      data: {
        reqId: window.uuid,
        latitude: window.lat,
        longitude: window.lot
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        console.log(data);
        var data = JSON.parse(data);
        outstanding = "TOTAL: $" + data.outstanding;
        if (window.lang == "cn") outstanding = "总额: $" + data.outstanding;
        sales = "$" + data.sales;
        salescommision = "$" + data["sales commission"];
        winningcommission = "$" + data["winning commission"];
        devicerental = data["device rental"];
        datarental = data["data rental"];
        var details_body = "";

        for (var i = 0; i < data.details.length; i++) {
          details_body += "\n          <tr>\n            <td class=\"label-cell\" style=\"font-size: 10px;\">" + data.details[i].orderId + "</td>\n            <td class=\"numeric-cell\">$" + data.details[i].total + "</td>\n            <td class=\"numeric-cell\">$" + data.details[i].commission + "</td>\n            <td class=\"numeric-cell\">$" + data.details[i].nett + "</td>\n          </tr>\n          ";
        }

        $(".details-body").html(details_body);
        $update();
        window.outstanding = data.outstanding;
      }
    });
  };

  var order = function order() {
    var url = "";
    if (window.wallet == "true") url = "json/walletPayBill.aspx";else url = 'json/outstanding.aspx';
    $f7.request({
      method: 'get',
      url: window.waypointGEN + url,
      data: {
        reqId: window.uuid,
        latitude: window.lat,
        longitude: window.lot,
        outstanding: window.outstanding
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        data = data.replace(",\"{", ",{");
        var data = JSON.parse(data);
        console.log(data);

        if (data.ALERT != undefined && data.ALERT != "") {
          $f7.dialog.alert(data.ALERT);
        }

        if (data.status == "1") {
          window.print_text = "{LEFT}";
          window.print_text += "{BR}";
          window.print_text += "{BR}Agent       : " + data.details[0].value;
          window.print_text += "{BR}Master      : " + data.details[1].value;
          window.print_text += "{BR}Sales       : $" + data.details[2].value;
          window.print_text += "{BR}Sales Comm. : $" + data.details[3].value; //window.print_text += "{BR}Win Comm.   : $" + data.details[4].value;

          window.print_text += "{BR}Rent Device : " + data.details[5].value;
          window.print_text += "{BR}Rent Data   : " + data.details[6].value;
          window.print_text += "{BR}";
          window.print_text += "{CENTER}";
          window.print_text += "{BR}{BR}";
          window.print_text += "{BR}{BR}OUTSTANDING TOTAL : $" + data.total;
          window.print_text += "{BR}{BR}";
          if (window.wallet != "true") window.print_qr = data.orderId; //window.print_barcode = data.orderId;

          window.print_hide_button = "true";
          if (window.wallet != "true") window.print_detail = "\n            <div class=\"block\">\n              Please present the QR to cashier for settlement:\n            </div>\n            ";
          window.print_detail = "\n            <div class=\"block\">\n              Amount has been deducted from e-Wallet\n            </div>\n            ";
          window.print_detail = "\n            <div class=\"card data-table\">\n            <table>\n              <thead>\n                <tr>\n                  <th class=\"label-cell\">Type</th>\n                  <th class=\"numeric-cell\">Description</th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr>\n                  <td class=\"label-cell\">Agent</td>\n                  <td class=\"numeric-cell\">" + data.details[0].value + "</td>\n                </tr>\n                <tr>\n                  <td class=\"label-cell\">Master</td>\n                  <td class=\"numeric-cell\">" + data.details[1].value + "</td>\n                </tr>\n                <tr>\n                  <td class=\"label-cell\">Sales</td>\n                  <td class=\"numeric-cell\">$" + data.details[2].value + "</td>\n                </tr>\n                <tr>\n                  <td class=\"label-cell\">Sales Commission</td>\n                  <td class=\"numeric-cell\">$" + data.details[3].value + "</td>\n                </tr>\n                <tr style=\"display:none\">\n                  <td class=\"label-cell\">Winning Commission</td>\n                  <td class=\"numeric-cell\">$" + data.details[4].value + "</td>\n                </tr>\n                <tr>\n                  <td class=\"label-cell\">Device Rental</td>\n                  <td class=\"numeric-cell\">" + data.details[5].value + "</td>\n                </tr>\n                <tr>\n                  <td class=\"label-cell\">Data Rental</td>\n                  <td class=\"numeric-cell\">" + data.details[6].value + "</td>\n                </tr>\n                <tr>\n                  <td class=\"label-cell\">Outstanding</td>\n                  <td class=\"numeric-cell\">" + data.details[7].value + "</td>\n                </tr>\n              </tbody>\n            </table>\n            <div class=\"data-table-footer\">\n              <H1 style=\"margin-right:16px\">TOTAL: $" + data.total + "</H1> \n            </div>\n          </div>\n            ";
          $f7.views.main.router.navigate("/GEN_receipt/");
        } else {
          $f7.dialog.alert(data.errmsg);
        }
      }
    });
  };

  $on('pageInit', function () {
    $('.wallet-amount').html("$" + window.wallet_amount);
    $(".card-details").hide();
    $("#orderId").focus();
    check();

    if (window.wallet == "true") {
      $(".wallet-off").hide();
      $(".wallet-on").show();
    } else {
      $(".wallet-off").show();
      $(".wallet-on").hide();
    }
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">
        <span class='en'>Outstanding</span>
        <span class='cn'>未完成交易</span>
        <span class='tl'>Debe</span>
      </div>
    </div>
  </div>
  <div class="page-content">


    <div class="data-table card wallet-on" style="background-color: var(--f7-theme-color);">
      <div class="card-content ">
        <table>
          <thead>
          <th >e-Wallet Amount</th>
          <th class="numeric-cell wallet-amount" style="font-size: 20px; color: white;"></th>
          </thead>
          <tbody>
          </tbody>  
        </table>
      </div>
    </div>


    <div class="block-title">
      <span class='en'>Pay My Bill</span>
      <span class='cn'>支付我的账单</span>
      <span class='tl'>Selu ha'u-nia Bill</span>
    </div>
    <div class="block wallet-off">
      <span class='en'>Generate QR Code and pay at Cashier Counter </span>
      <span class='cn'>生成二维码并在收银台付款</span>
      <span class='tl'>Kria kódigu QR no selu iha cashier</span>
    </div>

    <div class="card data-table">
      <table>
        <thead>
          <tr>
            <th class="label-cell">Type</th>
            <th class="numeric-cell">Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="label-cell">
              <span class='en'>Sales</span>
              <span class='cn'>销售</span>
              <span class='tl'>Fa'an</span>
            </td>
            <td class="numeric-cell" innerHTML=${sales}></td>
          </tr>
          <tr>
            <td class="label-cell">
              <span class='en'>Sales Commision</span>
              <span class='cn'>销售佣金</span>
              <span class='tl'>Fa'an komisionáriu</span>
            </td>
            <td class="numeric-cell" innerHTML=${salescommision}></td>
          </tr>
          <tr style="display: none;">
            <td class="label-cell">
              <span class='en'>Winning Commision</span>
              <span class='cn'>赢得佣金</span>
              <span class='tl'>Manán komisionáriu</span>
            </td>
            <td class="numeric-cell" innerHTML=${winningcommission}></td>
          </tr>
          <tr>
            <td class="label-cell">
              <span class='en'>Device Rental</span>
              <span class='cn'>设备租金</span>
              <span class='tl'>Instrumentu rentál</span>
            </td>
            <td class="numeric-cell" innerHTML=${devicerental}></td>
          </tr>
          <tr>
            <td class="label-cell">
              <span class='en'>Data Rental</span>
              <span class='cn'>互联网数据租金</span>
              <span class='tl'>Dadus rentál</span>
            </td>
            <td class="numeric-cell" innerHTML=${datarental}></td>
          </tr>
        </tbody>
      </table>
      <div class="data-table-footer">
        <H1 style="margin-right:16px" innerHTML=${outstanding}></H1> 
      </div>
    </div>

    <div class="list  inline-labels inset">
      <ul>
        <li>
          <p class="segmented">
            <button class="button button-fill button-active" @click="${details}">Details</button>
            <button class="button"></button>
            <button class="button button-fill button-active wallet-off" @click="${order}">
              <span class='en'>Generate QR</span>
              <span class='cn'>生成二维码</span>
              <span class='tl'>Kria QR</span>
            </button>
            <button class="button button-fill button-active wallet-on" @click="${order}">
              <span class='en'>Pay</span>
              <span class='cn'>支付</span>
              <span class='tl'>Selu</span>
            </button>
          </p>
        </li>
      </ul>
    </div>

    <div class="card data-table card-details">
      <table>
        <thead>
          <tr>
            <th class="label-cell">Order ID</th>
            <th class="numeric-cell">Total</th>
            <th class="numeric-cell">Comm.</th>
            <th class="numeric-cell">Nett</th>
          </tr>
        </thead>
        <tbody class="details-body">

          
        </tbody>
      </table>
    </div>

  </div>
</div>
`
    }
    ;
}

framework7Component.id = 'c2acb0dbb9';
export default framework7Component;